import { useId } from "react";

import { cn } from "@/lib/utils";

export function BannerIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[122px] w-[343px]", className)}
      fill="none"
      viewBox="0 0 343 122"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id}a)`}>
        <path
          d="M348.508-59.368H0v614.532h348.508V-59.368z"
          fill={`url(#${id}b)`}
        />
        <g opacity="0.22">
          <g opacity="0.5">
            <path
              d="M349.678 1393.55V-91.256H-.865V1393.55h350.543z"
              fill="#4D0D54"
            />
            <path
              d="M351.475 1407.1V-94.622H-3.226V1407.1h354.701z"
              fill={`url(#${id}c)`}
            />
            <path
              d="M335.386 116.159c41.001 41.063-11.522 68.536-60.399 95.354-49.733 26.763-95.873 52.801-61.43 90.961 29.129 33.404 117.717 56.278 128.033 94.747 8.629 38.143-49.87 71.287-69.065 99.899-18.6 24.103-32.63 55.173 8.28 79.532 27.228 16.494 71.119 17.983 75.618 49.069 5.123 59.219-137.797 50.553-46.02 128.568 16.858 14.869 38.664 29.011 52.295 47.341v-23.79c-8.525-8.126-17.677-15.735-25.728-23.551-40.51-39.005-29.528-56.349-4.777-71.337 9.152-5.671 20.254-11.012 30.505-17.067v-72.273c-13.457-5.325-28.763-9.701-40.46-17.03-39.604-24.343-22.297-55.412-.296-79.532 9.223-11.499 25.241-23.741 40.756-36.724V356.051c-30.925-17.81-70.496-33.887-88.118-53.598-35.246-38.209 14.504-64.251 67.355-90.944 6.974-3.58 13.947-7.177 20.763-10.806V83.893c-23.723-18.708-42.34-36.637-37.529-63.141 6.504-38.226 21.652-77.008 37.358-115.27h-34.322c-23.794 38.262-45.08 77.044-56.287 115.27-12.15 40.717 31.291 61.207 63.468 95.407z"
              fill="#4D0D54"
            />
            <path
              d="M212.792 116.159c31.133 41.063-16.213 68.537-58.952 95.354-43.442 26.764-82.242 52.801-50.219 90.961 27.315 33.404 107.553 56.278 122.527 94.747 13.456 38.143-33.016 71.288-45.899 99.899-12.691 24.103-21.457 55.173 20.916 79.532 28.468 16.494 70.878 17.983 81.598 49.069 18.496 59.306-132.324 50.64-29.806 128.654 25.885 19.971 64.183 38.593 77.065 67.844 20.779 44.519-12.691 86.606-24.65 115.844-5.231 14.819-4.375 26.038-4.375 43.451-.208 21.546-9.501 36.496-20.916 53.596-23.515 34.58-65.247 63.73-27.158 102.13 30.26 31.55 67.111 53.51 83.569 77.72 12.097 16.87 25.241 34.22 10.109 68.23-16.666 37.17-49.941 78.2-86.584 115.7h34.235c27.994-33.87 53.584-70.59 68.454-104.78v-73.19c-1.152-2.05-2.337-4.1-3.485-6.12-13.281-24.2-44.539-46.16-70.861-77.71-33.241-38.4 4.009-67.57 24.127-102.14 9.83-17.11 17.589-32.07 17.24-53.593-.437-17.409-1.501-28.632 2.665-43.451 9.552-29.152 37.915-71.234 20.463-115.844-10.895-29.185-45.932-47.807-70.337-67.777-97.74-78.01 49.176-69.349 36.938-128.655-7.843-31.123-51.006-32.575-78.982-49.069-41.837-24.342-30.664-55.412-15.166-79.532 15.847-28.615 68.142-61.76 56.898-99.899-12.812-38.468-97.304-61.343-125.63-94.747-33.295-38.159 9.136-64.197 55.779-90.961 45.758-26.731 95.715-54.204 59.705-95.267-27.89-34.2-67.061-54.686-50.814-95.407 15.373-38.222 41.903-77.004 72.653-115.267H259.61c-36.605 38.263-67.476 77.046-86.18 115.271-19.681 40.717 15.498 61.207 39.362 95.407z"
              fill="#4D0D54"
            />
            <path
              d="M85.644 20.752C61.081 61.469 88.85 81.959 105.5 116.159c22.663 41.063-19.278 68.536-55.78 95.284-37.095 26.763-68.769 52.801-39.848 90.961 24.771 33.404 95.994 56.278 114.161 94.747 16.804 38.143-19.261 71.287-27.261 99.899-8.038 24.103-13.282 55.173 29.303 79.532 28.746 16.494 69.639 17.983 84.733 49.069 28.343 59.305-129.917 50.64-21.178 128.654 28.031 19.954 71.976 38.572 87.802 67.827 25.765 44.52-19.174 86.606-36.709 115.844-7.689 14.819-7.531 26.038-8.716 43.451-1.742 21.543-14.225 36.493-29.178 53.593-30.593 34.58-81.336 63.74-33.121 102.14 38.472 31.55 87.157 53.51 110.639 77.71 17.12 17.03 35.824 34.38 17.153 68.38-20.533 37.18-61.359 78.2-105.915 115.71h34.201c41.176-37.5 78.688-78.53 97.616-115.71 17.186-34.01 1.343-51.35-13.161-68.38-19.872-24.2-62.528-46.16-96.834-77.71-43.092-38.4 3.14-67.57 30.139-102.14 13.195-17.11 24.056-32.07 24.963-53.593.54-17.409 0-28.632 6.395-43.451 14.591-29.152 53.621-71.234 30.069-115.844-14.521-29.255-55.78-47.877-82.887-67.843-106.178-78.01 48.406-69.349 24.563-128.655-13.145-31.123-54.807-32.575-83.532-49.069-42.689-24.342-35.89-55.412-25.694-79.532 10.267-28.615 51.334-61.76 36.015-99.899-16.754-38.468-92.563-61.343-118.69-94.747-30.592-38.143 4.653-64.181 44.922-90.874 39.62-26.747 84.28-54.221 57.526-95.284-20.081-34.2-51.442-54.686-28.988-95.407 21.461-38.296 55.838-77.078 97.117-115.34h-34.273C146.218-56.257 109.23-17.475 85.644 20.751z"
              fill="#4D0D54"
            />
            <path
              d="M57.65 116.159c-13.493-34.2-37.894-54.686-11.888-95.407 25.066-38.226 63.78-77.008 111.039-115.27h-34.235C74.018-56.257 34.448-17.475 8.546 20.751c-26.792 40.717-5.527 61.207 5.123 95.407 11.402 30.484-5.63 53.462-27.49 74.224v35.875c5.559-4.962 11.61-9.874 17.867-14.819 33.346-26.748 72.446-54.221 53.6-95.284l.005.004zM88.33-94.519H54.166a703.867 703.867 0 00-67.984 61.467V4.155C11.735-28.68 46.652-61.787 88.33-94.519z"
              fill="#4D0D54"
            />
          </g>
        </g>
        <path
          d="M30.872 36.282v3.692H17.066v-.832c.121-1.733.615-3.423 1.482-5.07.867-1.664 2.245-2.869 4.134-3.614l.858-.364c1.179-.468 2.063-.893 2.652-1.274.59-.381.884-.867.884-1.456 0-.503-.147-.936-.442-1.3a2.649 2.649 0 00-1.092-.806 3.204 3.204 0 00-1.3-.286c-1.023 0-1.88.2-2.574.598-.693.381-1.11.98-1.248 1.794l-3.666-.39c.156-1.144.59-2.132 1.3-2.964a7.02 7.02 0 012.704-1.898 9.041 9.041 0 013.484-.676c1.11 0 2.167.234 3.172.702 1.023.468 1.846 1.135 2.47 2.002.624.867.936 1.872.936 3.016s-.277 2.106-.832 2.886c-.555.78-1.3 1.43-2.236 1.95-.919.503-2.115 1.031-3.588 1.586-1.11.416-1.933 1.317-2.47 2.704h9.178zm8.85 4.056c-1.525 0-2.86-.39-4.004-1.17-1.144-.797-2.028-1.907-2.652-3.328-.624-1.439-.936-3.085-.936-4.94 0-1.855.312-3.493.936-4.914.624-1.439 1.508-2.548 2.652-3.328 1.144-.797 2.479-1.196 4.004-1.196 1.526 0 2.86.399 4.004 1.196 1.144.78 2.02 1.89 2.626 3.328.624 1.421.936 3.06.936 4.914 0 1.855-.312 3.501-.936 4.94-.606 1.421-1.482 2.53-2.626 3.328-1.144.78-2.478 1.17-4.004 1.17zm0-3.9c1.127 0 2.02-.45 2.678-1.352.659-.901.988-2.297.988-4.186 0-1.89-.329-3.285-.988-4.186-.658-.901-1.551-1.352-2.678-1.352-1.126 0-2.019.45-2.678 1.352-.658.901-.988 2.297-.988 4.186 0 1.89.33 3.285.988 4.186.659.901 1.552 1.352 2.678 1.352zm22.787-.156v3.692H48.703v-.832c.121-1.733.615-3.423 1.482-5.07.866-1.664 2.244-2.869 4.134-3.614l.858-.364c1.178-.468 2.062-.893 2.652-1.274.59-.381.884-.867.884-1.456 0-.503-.148-.936-.442-1.3a2.648 2.648 0 00-1.092-.806 3.204 3.204 0 00-1.3-.286c-1.023 0-1.88.2-2.574.598-.694.381-1.11.98-1.248 1.794l-3.666-.39c.156-1.144.59-2.132 1.3-2.964a7.02 7.02 0 012.704-1.898 9.042 9.042 0 013.484-.676c1.11 0 2.166.234 3.172.702 1.022.468 1.846 1.135 2.47 2.002.624.867.936 1.872.936 3.016s-.278 2.106-.832 2.886c-.555.78-1.3 1.43-2.236 1.95-.919.503-2.115 1.031-3.588 1.586-1.11.416-1.933 1.317-2.47 2.704h9.178zm13.608-5.928a5.454 5.454 0 011.56 1.846 5 5 0 01.546 2.314 5.02 5.02 0 01-.936 2.964c-.607.884-1.439 1.577-2.496 2.08-1.057.503-2.227.754-3.51.754-1.248 0-2.4-.234-3.458-.702-1.04-.485-1.872-1.153-2.496-2.002a4.91 4.91 0 01-.936-2.834l4.056-.286c.104.624.416 1.144.936 1.56.537.399 1.17.598 1.898.598.884 0 1.612-.217 2.184-.65.59-.433.884-.988.884-1.664 0-.693-.295-1.257-.884-1.69-.572-.45-1.3-.676-2.184-.676h-.988v-3.12h.988c.78 0 1.421-.182 1.924-.546.503-.364.754-.832.754-1.404s-.26-1.04-.78-1.404c-.52-.381-1.179-.572-1.976-.572-.572 0-1.11.13-1.612.39-.485.26-.823.598-1.014 1.014l-3.848-.234a4.37 4.37 0 011.04-2.366c.607-.71 1.378-1.265 2.314-1.664.953-.399 1.993-.598 3.12-.598 1.265 0 2.392.234 3.38.702.988.468 1.76 1.118 2.314 1.95.572.815.858 1.742.858 2.782a4.18 4.18 0 01-.442 1.898 4.703 4.703 0 01-1.196 1.56z"
          fill="#E92F7C"
        />
        <path
          d="M31.912 51.826V51.8h3.9V70h-3.9V58.976l-4.628 7.748h-.962l-4.654-7.774V70h-3.9V51.8h3.9v.026l.052-.026 5.07 8.528 5.07-8.528.052.026zM47.67 57h3.874l-4.368 12.818c-.728 1.872-1.716 3.267-2.964 4.186-1.23.919-2.704 1.317-4.42 1.196v-3.588c.104.017.26.026.468.026.728 0 1.335-.19 1.82-.572.485-.381.893-.91 1.222-1.586L37.686 57h4.004l3.406 7.462L47.67 57zm12.399 13V51.8h3.926V70h-3.926zm22.285-13.364c.763 0 1.534.165 2.314.494.78.33 1.448.91 2.002 1.742.555.832.832 1.95.832 3.354V70H83.81v-7.774c0-.832-.234-1.43-.702-1.794-.468-.364-1.022-.546-1.664-.546a2.14 2.14 0 00-1.404.494c-.381.312-.632.806-.754 1.482V70h-3.718v-7.774c0-.832-.234-1.43-.702-1.794-.468-.364-1.022-.546-1.664-.546a2.14 2.14 0 00-1.404.494c-.398.33-.65.858-.754 1.586V70h-3.718V57h3.718v.832c.954-.797 1.985-1.196 3.094-1.196.763 0 1.534.165 2.314.494.798.33 1.448.875 1.95 1.638a5.556 5.556 0 011.716-1.508 4.271 4.271 0 012.236-.624zm22.598 0c.763 0 1.534.165 2.314.494.78.33 1.447.91 2.002 1.742.555.832.832 1.95.832 3.354V70h-3.692v-7.774c0-.832-.234-1.43-.702-1.794-.468-.364-1.023-.546-1.664-.546a2.14 2.14 0 00-1.404.494c-.381.312-.633.806-.754 1.482V70h-3.718v-7.774c0-.832-.234-1.43-.702-1.794-.468-.364-1.023-.546-1.664-.546a2.14 2.14 0 00-1.404.494c-.399.33-.65.858-.754 1.586V70h-3.718V57h3.718v.832c.953-.797 1.985-1.196 3.094-1.196.763 0 1.534.165 2.314.494.797.33 1.447.875 1.95 1.638a5.563 5.563 0 011.716-1.508 4.271 4.271 0 012.236-.624zm13.732.026c1.265 0 2.392.303 3.38.91a6.294 6.294 0 012.34 2.47c.554 1.04.832 2.193.832 3.458 0 .485-.035.927-.104 1.326h-9.62c.329.797.771 1.395 1.326 1.794.554.381 1.274.572 2.158.572.537 0 1.057-.113 1.56-.338.52-.225.927-.529 1.222-.91l2.808 1.664a5.967 5.967 0 01-2.366 2.028c-.954.468-2.054.702-3.302.702-1.404 0-2.644-.295-3.718-.884a6.446 6.446 0 01-2.496-2.47c-.59-1.04-.884-2.201-.884-3.484s.286-2.444.858-3.484a6.365 6.365 0 012.444-2.444c1.04-.607 2.227-.91 3.562-.91zm3.068 5.278a2.23 2.23 0 00-1.04-1.534c-.555-.364-1.24-.546-2.054-.546-.85 0-1.586.208-2.21.624-.624.399-.954.884-.988 1.456h6.292zm13.584-5.2l-.26 3.51c-.121-.052-.321-.078-.598-.078-1.057 0-1.924.303-2.6.91-.659.59-.988 1.37-.988 2.34V70h-3.718V57h3.718v2.106c.312-.676.815-1.24 1.508-1.69.693-.45 1.534-.676 2.522-.676h.416zm4.762 3.952c0 .295.182.52.546.676.364.139.944.286 1.742.442 1.022.208 1.872.442 2.548.702.676.243 1.265.659 1.768 1.248.52.572.78 1.37.78 2.392 0 .884-.269 1.647-.806 2.288-.538.624-1.248 1.1-2.132 1.43a8.536 8.536 0 01-2.86.468c-1.404 0-2.6-.251-3.588-.754a5.096 5.096 0 01-2.236-2.288l3.042-1.56c.416 1.11 1.343 1.664 2.782 1.664.589 0 1.1-.104 1.534-.312.45-.225.676-.537.676-.936 0-.347-.208-.607-.624-.78-.399-.173-1.04-.355-1.924-.546-1.006-.225-1.846-.46-2.522-.702a4.614 4.614 0 01-1.742-1.17c-.486-.537-.728-1.248-.728-2.132 0-.85.242-1.586.728-2.21.485-.641 1.135-1.127 1.95-1.456a7.28 7.28 0 012.704-.494c1.144 0 2.175.234 3.094.702a5.186 5.186 0 012.158 2.028l-3.016 1.482c-.208-.433-.494-.754-.858-.962-.347-.208-.806-.312-1.378-.312-.503 0-.902.104-1.196.312-.295.19-.442.45-.442.78zm11.164-5.46c-.693 0-1.239-.182-1.638-.546-.381-.381-.572-.893-.572-1.534 0-.659.191-1.179.572-1.56.399-.381.945-.572 1.638-.572.676 0 1.213.19 1.612.572.399.381.598.901.598 1.56 0 .641-.199 1.153-.598 1.534-.399.364-.936.546-1.612.546zM149.39 70V57h3.718v13h-3.718zm12.29-4.602L164.722 57h3.926l-4.732 13h-4.498l-4.732-13h3.926l3.068 8.398zm14.031-8.736c1.265 0 2.392.303 3.38.91a6.294 6.294 0 012.34 2.47c.555 1.04.832 2.193.832 3.458 0 .485-.035.927-.104 1.326h-9.62c.329.797.771 1.395 1.326 1.794.555.381 1.274.572 2.158.572.537 0 1.057-.113 1.56-.338.52-.225.927-.529 1.222-.91l2.808 1.664a5.96 5.96 0 01-2.366 2.028c-.953.468-2.054.702-3.302.702-1.404 0-2.643-.295-3.718-.884a6.446 6.446 0 01-2.496-2.47c-.589-1.04-.884-2.201-.884-3.484s.286-2.444.858-3.484a6.365 6.365 0 012.444-2.444c1.04-.607 2.227-.91 3.562-.91zm3.068 5.278a2.226 2.226 0 00-1.04-1.534c-.555-.364-1.239-.546-2.054-.546-.849 0-1.586.208-2.21.624-.624.399-.953.884-.988 1.456h6.292zM27.83 100l-3.38-6.084h-2.782V100h-3.9V81.8h7.514c1.11 0 2.123.269 3.042.806a5.88 5.88 0 012.21 2.21c.555.919.832 1.933.832 3.042a5.867 5.867 0 01-.806 3.016 5.86 5.86 0 01-2.132 2.184l3.9 6.942H27.83zm-6.162-14.482v4.68h3.614c.641 0 1.196-.225 1.664-.676.468-.468.702-1.023.702-1.664a2.19 2.19 0 00-.702-1.638 2.22 2.22 0 00-1.664-.702h-3.614zm17.72 1.144c1.266 0 2.393.303 3.38.91a6.289 6.289 0 012.34 2.47c.555 1.04.833 2.193.833 3.458 0 .485-.035.927-.104 1.326h-9.62c.329.797.771 1.395 1.326 1.794.554.381 1.274.572 2.158.572.537 0 1.057-.113 1.56-.338.52-.225.927-.529 1.222-.91l2.808 1.664a5.96 5.96 0 01-2.366 2.028c-.954.468-2.054.702-3.302.702-1.404 0-2.644-.295-3.718-.884a6.452 6.452 0 01-2.496-2.47c-.59-1.04-.884-2.201-.884-3.484s.286-2.444.858-3.484a6.368 6.368 0 012.444-2.444c1.04-.607 2.227-.91 3.562-.91zm3.069 5.278a2.227 2.227 0 00-1.04-1.534c-.555-.364-1.24-.546-2.054-.546-.85 0-1.586.208-2.21.624-.624.399-.954.884-.988 1.456h6.292zm17.172 5.512a7.148 7.148 0 01-2.444 2.158c-.97.52-2.02.78-3.146.78-1.248 0-2.4-.303-3.458-.91a7.102 7.102 0 01-2.496-2.522 6.78 6.78 0 01-.91-3.432c0-1.248.303-2.392.91-3.432a6.893 6.893 0 012.496-2.496 6.682 6.682 0 013.458-.936 6.56 6.56 0 013.146.78 7.075 7.075 0 012.418 2.106l-3.068 2.028c-.728-.815-1.56-1.222-2.496-1.222-.867 0-1.612.312-2.236.936-.624.624-.936 1.37-.936 2.236 0 .867.312 1.612.936 2.236.624.607 1.37.91 2.236.91.936 0 1.768-.407 2.496-1.222l3.094 2.002zM70.834 87h3.692v13h-3.692v-.988a6.39 6.39 0 01-1.898.988 6.031 6.031 0 01-2.054.364c-1.352 0-2.522-.295-3.51-.884a5.9 5.9 0 01-2.236-2.418c-.52-1.04-.78-2.219-.78-3.536 0-1.317.26-2.496.78-3.536.52-1.057 1.266-1.88 2.236-2.47.988-.59 2.158-.884 3.51-.884.711 0 1.404.121 2.08.364a7 7 0 011.872 1.014V87zm-3.458 9.828c.971 0 1.786-.312 2.444-.936.66-.624.988-1.43.988-2.418 0-.953-.329-1.733-.988-2.34-.658-.607-1.473-.91-2.444-.91-.97 0-1.768.303-2.392.91-.624.607-.936 1.404-.936 2.392s.312 1.785.936 2.392c.624.607 1.422.91 2.392.91zm17.979-10.166c1.352 0 2.513.295 3.484.884a5.812 5.812 0 012.262 2.444c.52 1.023.78 2.193.78 3.51 0 1.317-.26 2.496-.78 3.536a5.982 5.982 0 01-2.262 2.47c-.97.589-2.132.884-3.484.884a6.031 6.031 0 01-2.054-.364 6.467 6.467 0 01-1.872-.988v6.162h-3.718V87h3.718v1.014a6.557 6.557 0 011.846-.988 6.111 6.111 0 012.08-.364zm-.494 10.114c.97 0 1.76-.295 2.366-.884.624-.607.936-1.404.936-2.392s-.312-1.785-.936-2.392c-.607-.607-1.395-.91-2.366-.91-.97 0-1.785.312-2.444.936-.659.624-.988 1.421-.988 2.392 0 .97.32 1.76.962 2.366.659.59 1.482.884 2.47.884z"
          fill="#fff"
        />
        <g clipPath={`url(#${id}d)`} opacity="0.2">
          <path
            d="M350.506 33.917c-.85 2.655-3.529 3.661-6.103 3.812-4.592.27-9.417-.547-13.901.772-1.51.444-2.961 1.242-3.917 2.492-1.214 1.586-1.613 3.62-2.812 5.227-.912 1.222-2.044 2.276-3.269 3.177-2.654 1.953-5.807 3.221-9.016 3.915-4.253.919-9.132 1.018-13.126-.932-4.184-2.044-6.544-6.816-7.922-11.07-1.464-4.523-2.5-8.91-7.913-9.684-1.881-.27-3.824-.232-5.633-.815-2.149-.692-2.964-2.218-2.983-4.37-.059-6.698 7.466-12.22 13.707-12.398 5.781-.163 9.858 3.87 14.907 5.946 6.112 2.513 12.837.712 18.786-1.37 6.113-2.14 13.293-2.7 19.389-.203 5.337 2.186 11.84 9.155 9.806 15.501z"
            fill={`url(#${id}e)`}
          />
        </g>
        <g clipPath={`url(#${id}f)`} opacity="0.2">
          <path
            d="M219.154 115.083c1.215-3.267 5.39-4.223 9.441-4.106 7.226.208 14.872 1.824 21.879.687 2.36-.382 4.61-1.221 6.058-2.693 1.838-1.867 2.372-4.4 4.187-6.297 1.379-1.441 3.115-2.644 5.004-3.64 4.091-2.16 9.002-3.393 14.028-3.888 6.662-.656 14.348-.198 20.736 2.757 6.692 3.096 10.638 9.435 13.01 15.001 2.523 5.916 4.361 11.608 12.931 13.24 2.979.568 6.039.753 8.92 1.71 3.421 1.137 4.776 3.171 4.908 5.905.409 8.508-11.195 14.615-21.024 14.092-9.107-.486-15.724-6.095-23.782-9.335-9.754-3.922-20.271-2.443-29.551-.513-9.535 1.982-20.828 1.832-30.556-2.068-8.516-3.415-19.096-13.041-16.189-20.852z"
            fill={`url(#${id}g)`}
          />
        </g>
        <path
          d="M296.374 107.443l-.278-15.466 4.316 2.022.434 13.444h-4.472zm-22.763-.925l3.92-14.541 4.316 2.022-3.763 12.519h-4.473z"
          fill="#CE5E60"
        />
        <path
          d="M281.6 67.39c2.281-2.392 14.375-2.537 17.401-3.752 1.009 1.715 2.053 3.645 2.918 9.54.864 5.897-.721 19.583-1.297 27.444h-5.027l-5.24-25.234s-5.908 17.23-8.755 25.234h-7.389s5.109-30.84 7.389-33.232z"
          fill="#4D0D54"
        />
        <path
          d="M274.613 94.752h10.233l-2.42 7.99h-10.243l2.43-7.99z"
          fill="#BA3491"
        />
        <path
          d="M278.982 104.227l-.204 6.942-15.628-.418c-.429-.222-.877-1.259.766-3.632 1.643-2.374 5.72-1.253 7.553-.397l2.684-2.793 4.829.298z"
          fill="#4D0D54"
        />
        <path
          d="M301.594 94.954h-7.776v7.903h10.198l-2.422-7.903z"
          fill="#BA3491"
        />
        <path
          d="M291.079 35.58c-5.832.767-15.131 5.385-16.94 6.781 0 7.56-1.433 10.368-2.861 11.413 3.007 0 10.431-2.948 12.367-4.191.541 1.215.661-.304.661 2.205 0 2.508-.254 12.44-1.649 13.88 6.664.706 16.472 2.42 16.714 1.616 1.031-3.42 3.526-10.16 4.181-13.549l1.88.836 11.789 1.697c-5.624-22.26-18.852-21.646-26.142-20.688z"
          fill="#CCDAFF"
        />
        <path
          clipRule="evenodd"
          d="M302.907 56.32l-4.703-1.555c.366 3.375-.152 10.192-5.146 10.46-3.485.187 1.206.737 6.576 1.214.311-.979.699-2.135 1.11-3.364.747-2.228 1.573-4.691 2.163-6.755z"
          fill="#A3B7EE"
          fillRule="evenodd"
        />
        <path
          d="M287.364 22.931c1.297-.94 2.354-.392 3.36 0 2.818 2.73 1.174 9.333 0 12.294-1.699 1.6-3.801 1.647-4.64 1.47 1.454-.764.282-5.268-.445-7.856-.581-2.07.775-4.222 1.26-5.359l.465-.549z"
          fill="#4D0D54"
        />
        <path
          d="M294.55 37.023c-.832 1.358-4.319 2.33-4.319-.86V32.76c.697-.357 3.406-.447 4.432-.558 0 0 .719 3.46-.113 4.82z"
          fill="#F3898A"
        />
        <path
          clipRule="evenodd"
          d="M294.923 34.172c-1.538.64-3.592.191-4.692-.223V32.76c.517-.264 2.14-.382 3.363-.47.426-.031.804-.058 1.069-.087 0 0 .188.903.26 1.969z"
          fill="#CE5E60"
          fillRule="evenodd"
        />
        <path
          d="M287.848 27.234c.057-2.797.456-4.7.891-5.452 1.98-.203 7.041.07 9.05 2.11 2.008 2.04.632 5.689-.307 7.257-1.207 1.063-2.641 1.61-4.048 1.844-3.239.54-5.653-2.477-5.586-5.76z"
          fill="#F3898A"
        />
        <path
          d="M290.259 27.92c-.143.336-.43 1.117-.43 1.552 0 .435.469.595.704.621m.477 1.518c.274.12.93.256 1.358-.161"
          stroke="#CE5E60"
          strokeLinecap="round"
          strokeWidth="1.113"
        />
        <ellipse
          cx="0.286"
          cy="0.69"
          fill="#4D0D54"
          rx="0.286"
          ry="0.69"
          transform="matrix(-1 0 0 1 292.571 26.567)"
        />
        <ellipse
          cx="0.286"
          cy="0.69"
          fill="#4D0D54"
          rx="0.286"
          ry="0.69"
          transform="matrix(-1 0 0 1 288.84 26.567)"
        />
        <path
          d="M293.583 25.118c-.372-.196-1.33-.513-2.188-.221m-1.532.058c-.397-.138-1.392-.312-2.198.103"
          stroke="#4D0D54"
          strokeLinecap="round"
          strokeWidth="1.113"
        />
        <path
          d="M299.695 24.8c1.311.311 4.65 1.939 7.515 5.968-1.293-.285-4.606-1.877-7.515-5.967z"
          fill="#922671"
        />
        <path
          d="M303.339 31.566c-1.611-1.256-2.936-4.753-3.398-6.345 1.899.858 5.204 5.952 6.619 8.392-.402-.159-1.609-.79-3.221-2.047z"
          fill="#922671"
        />
        <path
          d="M287.817 29.755c-.182-5.843 1.778-5.893 2.142-7.205-.874-.707-2.253.137-2.53.385-.493 1.238.417 7.747.388 6.82z"
          fill="#4D0D54"
        />
        <path
          d="M293.575 56.554c-.041-6.962 1.327-18.089 2.017-21.767 2.15-.432 6.643 1.177 8.412 1.998-1.05 3.532-3.872 9.541-3.202 12.976.67 3.434 1.961 4.078 3.122 4.3l-1.161 5.642-9.188-3.15zm-9.951 1.2c0-1.416-.422-14.292 1.052-20.191.683-.801 3.81-2.235 5.434-2.234-1.683 6.33-1.052 21.176-1.052 21.176l-5.434 1.25z"
          fill="#3469BA"
        />
        <path
          d="M301.76 68.386a3.862 3.862 0 00-.029-1.892c-.139-.536-.583-.923-1.101-1.12a46.156 46.156 0 00-16.097-3.032 2.118 2.118 0 00-1.31.415c-1.557 1.172-2.431 2.217-2.939 3.194-.653 1.256.598 2.531 2.014 2.523 4.893-.03 13.023.47 17.853.83.706.053 1.438-.231 1.609-.918z"
          fill="#BA3491"
        />
        <path
          d="M299.833 38.843c-1.414 3.033-5.489 2.944-7.636 3.305 2.58-4.782 1.843-9.845 1.334-13.613-1.356-1.35-3.222-5.231-3.048-7.02 1.961 0 7.564.39 9.35 2.737 1.357 3.679 1.414 11.558 0 14.591z"
          fill="#4D0D54"
        />
        <path
          d="M300.275 25.15c-3.592-2.284-10.355-1.975-13.287-1.536.016-7.282 7.269-8.333 11.017-5.42 2.998 2.33 2.534 5.576 2.27 6.956z"
          fill="#922671"
        />
        <path
          clipRule="evenodd"
          d="M297.393 23.96c-2.379-.624-5.164-.723-7.433-.62a32.966 32.966 0 00-2.968-.004c.11-3.903 2.352-5.944 4.958-6.494 1.1.223 2.145.683 3.005 1.351 2.321 1.803 2.568 4.156 2.438 5.766z"
          fill="#BA3491"
          fillRule="evenodd"
        />
        <path
          d="M246.006 26.928l27.878.276v2.473l-28.785 5.419.907-8.168z"
          fill="#F3A21A"
        />
        <path
          clipRule="evenodd"
          d="M273.884 29.478v.2l-28.785 5.418.338-3.045 28.381-3.111.066.538z"
          fill="#D88F14"
          fillRule="evenodd"
        />
        <path
          d="M244.797 35.892l1.284-10.078h2.795l-1.511 10.078h-2.568z"
          fill="#C97718"
        />
        <path
          d="M265.987 34.302l4.987 6.888c1.253 1.355 2.448 4.76-1.202 7.559-.793-.306-6.894-13.437-7.732-14.093-.67-.525-.979-2.06-1.049-2.748l3.47-.595c-.357-1.337.839-2.562 1.28-1.014.441 1.547.451 3.067.246 4.003z"
          fill="#F3898A"
        />
        <path
          d="M271.131 40.855c1.639 0 2.391 1.157 3.074 1.609.303 3.5-.476 10.107-3.074 11.405-3.188.723-4.365-.903-4.554-1.806 2.212-4.881 4.554-9.211 4.554-11.208z"
          fill="#3469BA"
        />
        <path
          d="M297.173 65.57c-.463-2.036 6.643-6.94 10.236-10.064l6.712 2.466-12.262 7.597.188 1.117c.533.569 1.094 1.501-1.514 2.042-3.26.676-3.206-2.484-3.36-3.159z"
          fill="#F3898A"
        />
        <path
          d="M258.789 33.532l.352-7.302h2.329l-.434 7.302h-2.247z"
          fill="#C97718"
        />
        <path
          d="M306.549 53.237c-.606.339-1.101 1.38-1.274 2.242 1.978 1.377 7.547 4.42 9.755 5.337 1.797.345 3.281-3.289 2.341-4.647-2.028-2.932-9.894-3.449-10.822-2.932z"
          fill="#3469BA"
        />
        <path
          d="M273.307 30.756l.352-4.526h1.862l-.578 4.526h-1.636z"
          fill="#C97718"
        />
        <path
          d="M297.547 105.837c-2.536.656-3.336 4.037-2.919 5.555h8.674c.167-4.735-2.586-6.374-5.755-5.555z"
          fill="#4D0D54"
        />
        <path
          d="M296.323 104.823v1.787l4.722.327-.329-2.114h-4.393z"
          fill="#4D0D54"
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}c`}
          x1="-3.157"
          x2="351.461"
          y1="657.096"
          y2="657.096"
        >
          <stop stopColor="#90278E" />
          <stop offset="1" stopColor="#EC297B" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}e`}
          x1="306.245"
          x2="316.424"
          y1="54.612"
          y2="12.327"
        >
          <stop stopColor="#00D1FF" />
          <stop offset="1" stopColor="#256FFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${id}g`}
          x1="287.955"
          x2="273.901"
          y1="94.125"
          y2="146.575"
        >
          <stop stopColor="#00D1FF" />
          <stop offset="1" stopColor="#256FFF" />
        </linearGradient>
        <clipPath id={`${id}a`}>
          <rect fill="#fff" height="122" rx="10" width="343" />
        </clipPath>
        <clipPath id={`${id}d`}>
          <path
            d="M279.189 3.362l74.384 17.905-10.18 42.296-74.385-17.905z"
            fill="#fff"
          />
        </clipPath>
        <clipPath id={`${id}f`}>
          <path
            d="M333.022 162.419l-118.109-31.647 14.058-52.463 118.108 31.647z"
            fill="#fff"
          />
        </clipPath>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="scale(174.254 307.266) rotate(90 .097 .903)"
          gradientUnits="userSpaceOnUse"
          id={`${id}b`}
          r="1"
        >
          <stop stopColor="#22377C" />
          <stop offset="1" stopColor="#191F34" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export function CheckmarkIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4 text-rose-red", className)}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M5.86 9.605l6.418-6.314a1.02 1.02 0 011.427 0 .98.98 0 010 1.403l-7.131 7.015a1.02 1.02 0 01-1.426 0L2.295 8.903a.98.98 0 010-1.403 1.02 1.02 0 011.427 0L5.86 9.605z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function CloseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-[15px] text-white", className)}
      viewBox="0 0 15 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.285 14.126a6.789 6.789 0 01-2.727-.554 7.124 7.124 0 01-2.256-1.524A7.276 7.276 0 01.777 9.792a6.788 6.788 0 01-.553-2.728c0-.966.184-1.875.553-2.727A7.241 7.241 0 014.55.557 6.788 6.788 0 017.279.003c.971 0 1.882.184 2.735.554.852.369 1.604.88 2.256 1.53a7.137 7.137 0 011.53 2.25c.37.852.555 1.761.555 2.727 0 .967-.185 1.876-.554 2.728a7.22 7.22 0 01-3.787 3.78 6.789 6.789 0 01-2.728.554zm-2.242-4.17a.677.677 0 00.478-.185l1.771-1.784 1.777 1.784a.63.63 0 00.465.185.622.622 0 00.458-.185.625.625 0 00.192-.458.597.597 0 00-.192-.458L8.208 7.071l1.791-1.784a.64.64 0 00.191-.458.603.603 0 00-.191-.451.603.603 0 00-.451-.191.625.625 0 00-.458.19L7.292 6.163 5.501 4.378a.65.65 0 00-.458-.178.637.637 0 00-.458.185.608.608 0 00-.185.458c0 .168.064.319.192.45l1.784 1.778-1.784 1.791a.603.603 0 00-.192.451.633.633 0 00.643.643z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ModalCloseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-6.5 text-white", className)}
      fill="none"
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g stroke="currentColor">
        <rect height="24" rx="12" width="24" x="1" y="0.575" />
        <path
          d="M9.875 9.45l6.25 6.25m0-6.25l-6.25 6.25"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
}
